import { useTranslation } from "react-i18next";
import KiloNewton from "../../../../../../components/Math/Units/Metric/KiloNewton";
import { NumberFormatText } from "../../../../../../components/NumberFormatText";
import { RowBody } from "../../../../../../components/RowValue/RowBody";
import ToolTip, { IconType } from "../../../../../../components/ToolTip";

function BemessungswertDerNormalkraftTragfaehigkeit({ normalkrafttragfaehigkeit }) {
  const { t } = useTranslation("translation");
  const N_Rd_Formula = `\\displaystyle N_{\\tiny _{Rd}} = A_{s} \\cdot  \\frac{f_{\\tiny _{yk}}}{\\gamma_{\\tiny  _{M}}} + 0,85 \\cdot A_{c} \\cdot 0,85 \\cdot \\frac{f_{\\tiny _{ck}}}{\\gamma_{\\tiny _c}}`;

  return (
    <RowBody
      titleValue={
        <p>
          {t(
            "inner.buckling.ofner.loadbearingCapacitiesMicropile.designValueNormalForceBearingCapacity"
          )}
        </p>
      }
      indicesValue={
        <span>
          N<sub>Rd</sub>
        </span>
      }
      formulaValue={<ToolTip id={"N_Rd_Formula"} type={IconType.FORMULA} formula={N_Rd_Formula} />}
      inputValue={
        <span className="input">
          <NumberFormatText value={normalkrafttragfaehigkeit} decimalScale={0} />
        </span>
      }
      unitValue={<KiloNewton />}
    />
  );
}

export default BemessungswertDerNormalkraftTragfaehigkeit;
